import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit5-conclusion',
  templateUrl: './unit5-conclusion.component.html',
  styleUrls: ['./unit5-conclusion.component.css']
})
export class Unit5ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
